import { Link } from "react-router-dom";
import { PackageSearch, ArrowRight } from "lucide-react";

export default function CekStatusInline() {
    return (
        <section
            data-testid="cek-status-section"
            className="wx-container mt-10"
        >
            <div className="wx-card p-5">
                <div className="flex items-start gap-3">
                    <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-[color:var(--wx-blueSoft)] text-[color:var(--wx-blue)]">
                        <PackageSearch className="w-4 h-4" />
                    </span>
                    <div className="min-w-0">
                        <p className="text-[15px] font-semibold text-[color:var(--wx-ink)] leading-tight">
                            Cek Status Pesanan
                        </p>
                        <p className="mt-1 text-xs text-[color:var(--wx-muted)] leading-relaxed">
                            Masukkan nomor WhatsApp dan kode akses untuk melihat pesanan.
                        </p>
                    </div>
                </div>

                <Link
                    to="/order"
                    data-testid="cek-status-cta"
                    className="wx-btn-primary mt-4 inline-flex w-full sm:w-auto items-center justify-center gap-2 h-11 px-5 rounded-xl text-sm font-semibold"
                >
                    Cek Pesanan
                    <ArrowRight className="w-4 h-4" />
                </Link>
            </div>
        </section>
    );
}
